import solicitudes from './solicitudes.js';

export const obtenerCuentasPorPagar = async (id_usuario, sucursal = null) => {
    try {
        const qs = sucursal ? `?sucursal=${sucursal}` : '';
        return await solicitudes.fetchRegistrosAuth(`/cuentas-por-pagar/${id_usuario}${qs}`);
    } catch (error) {
        console.error('Error al obtener cuentas por pagar:', error);
        throw new Error('No se pudieron obtener las cuentas por pagar.');
    }
};

export const obtenerCuentasPorPagarPorSucursal = (id_sucursal) =>
    solicitudes.fetchRegistrosAuth(`/cuentas-por-pagar/sucursal/${id_sucursal}`);

export const obtenerComprasPendientesPorProveedor = async (id_proveedor, id_usuario) => {
    try {
        return await solicitudes.fetchRegistrosAuth(`/cuentas-por-pagar/compras/${id_proveedor}/${id_usuario}`);
    } catch (error) {
        console.error('Error al obtener compras pendientes:', error);
        throw new Error('No se pudieron obtener las compras pendientes del proveedor.');
    }
};

export const registrarPagoProveedor = async (datosPago, id_usuario) => {
    try {
        return await solicitudes.postRegistroAuth(`/cuentas-por-pagar/pagar/${id_usuario}`, datosPago);
    } catch (error) {
        console.error('Error al registrar pago a proveedor:', error);
        throw new Error('No se pudo registrar el pago.');
    }
};

export const obtenerHistorialPagosProveedor = async (id_proveedor, id_usuario) => {
    try {
        return await solicitudes.fetchRegistrosAuth(`/cuentas-por-pagar/historial/${id_proveedor}/${id_usuario}`);
    } catch (error) {
        console.error('Error al obtener historial de pagos:', error);
        throw new Error('No se pudo obtener el historial de pagos.');
    }
};

export default {
    obtenerCuentasPorPagar,
    obtenerCuentasPorPagarPorSucursal,
    obtenerComprasPendientesPorProveedor,
    registrarPagoProveedor,
    obtenerHistorialPagosProveedor
};
